<template>
  <Card class="layout-card">
    <div style="margin-bottom: 10px;">
      <Row :gutter="10">
        <Col :span="6">
        <RadioGroup v-model="searchForm.timeType" type="button" button-style="solid"
          style="width: 100%;display:flex;padding:0">
          <Radio label="day" style="width:calc(100% / 3);text-align: center;">日报</Radio>
          <Radio label="week" style="width:calc(100% / 3);text-align: center;">周报</Radio>
          <Radio label="month" style="width:calc(100% / 3);text-align: center;">月报</Radio>
        </RadioGroup>
        </Col>
        <Col :span="7" class="date-picker">
        <Select v-model="searchForm.timeZone" placeholder="请选择时区"
          style="width: 30%;border-top-right-radius: 0px;border-bottom-right-radius: 0px;" @on-change="changeTimeZone">
          <Option :value="-8" label="美国时间">美国时间(西八区 UTC-8)</Option>
          <Option :value="8" label="北京时间">北京时间(东八区 UTC+8)</Option>
        </Select>
        <DatePicker format="yyyy-MM-dd" type="daterange" style="width: 70%;" placeholder="请选择日期" :value="listDate" :editable="false"
          :options="options" @on-change="getListDate" :clearable="false"></DatePicker>
        </Col>
        <Col :span="3">
        <Select v-model="searchForm.channels" placeholder="推广渠道">
          <Option value="-2">全部渠道</Option>
          <Option value="0">facebook</Option>
          <Option value="1">tiktok</Option>
          <Option value="2">google</Option>
          <Option value="3">Apple Search Ads</Option>
          <Option value="-1">其他</Option>
        </Select>
        </Col>
        <Col :span="2">
        <Select transfer placeholder="推广目标" clearable v-model="searchForm.advertiseTypes">
          <Option :value="0">W2A</Option>
          <Option :value="1">直投</Option>
        </Select>
        </Col>
        <Col :span="1">
        <Button type="primary" @click="getData()">查询</Button>
        <Modal v-model="visible" footer-hide :width="1000" title="自定义字段编辑">
          <fieldSelector v-model="column" :orgin="flagColumn" @upload:visible="visible = false"
            @upload:column="submitColumn" />
        </Modal>
        </Col>
        <!-- <Button style="width: auto;" @click="handleReset()">重置</Button> -->
        <div style="flex-grow: 1;text-align: right;padding-right: 12px;padding: 0 5px">
          <Tooltip transfer content="点击下载">
            <Button style="padding:4px 5px" :loading="exportLoading" @click="handleExport">
              <Icon type="md-download" :size="20" />
            </Button>
          </Tooltip>
          <Tooltip transfer content="自定义列">
            <Button style="margin-left: 10px;padding:4px 5px" @click="visible = true">
              <Icon type="md-options" :size="20" />
            </Button>
          </Tooltip>

        </div>
      </Row>
      <!-- </div> -->
    </div>
    <div>
      <Table border ref="tableRef" :data="tableData" :columns="columns" show-summary :loading="loading" :summary-method="handleSummary"
        @on-sort-change="handleSort">
        <Pages slot="footer" :page="page" :func="getData" :pArr="[31, 50]"></Pages>
      </Table>
    </div>
    <RadioGroup v-model="flag" type="button" style="margin: 20px 0 0 auto" button-style="solid">
      <Radio :label="1" style="width: 7em;text-align: center;">新用户</Radio>
      <Radio :label="2" style="width: 7em;text-align: center;">染色用户</Radio>
    </RadioGroup>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getDictionaryList } from '@/api/dictionary'
import { getDataNew as getTableData, exportData } from '@/api/data'
import dayjs from 'dayjs'
import { columnData } from '.'
import { utils, writeFile } from 'xlsx'
import { cloneDeep } from 'lodash'
import fieldSelector from '../../components/fieldSelector/index.vue'
export default {
  name: 'dataNew',
  components: {
    Pages,
    fieldSelector
  },
  data() {
    return {
      columnData,
      tableHeight: '400px',
      visible: false,
      exportLoading: false,
      loading: false,
      searchForm: {
        timeType: 'day',
        timeZone: -8,
        channels: '-2'
      },
      flagColumn: [],
      listDate: [],
      page: {
        current: 1,
        size: 31,
        total: 0
      },
      tableData: [],
      column: [],
      columns: [],
      realData: [],
      sum: {},
      newColumn: [],
      flag: 1
    }
  },
  watch: {
    'tableData': {
      handler() {
        if (!this.tableData.length) {
          this.tableHeight = '400px'

        } else {
          this.tableHeight = '24px'
        }
      },
      deep: true
    },
    flag() {
      const li = [...this.column]
      this.column = []
      this.column = li.map(i => {
        const obj = this.newColumn.find(j => j.key.includes(i)) || {}
        if (obj.flag && this.flag == 1) {
          return i.replaceAll('All', 'New')
        } else if (obj.flag && this.flag == 2) return i.replaceAll('New', 'All')
        return i
      })
      this.flagColumn = this.newColumn.filter(i => !i.flag || i.flag == this.flag)
      this.submitColumn()
    },
  },
  computed: {
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('data')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    },
    options() {
      return {
        shortcuts: [
          {
            text: '今日',
            value() {
              return [dayjs().add(-16, 'hour').toDate(), dayjs().add(-16, 'hour').toDate()];
            }
          },
          {
            text: '近三天',
            value() {
              return [dayjs().add(-16, 'hour').add(-2, 'day').toDate(), dayjs().add(-16, 'hour').toDate()];
            }
          },
          {
            text: '近七天',
            value() {
              return [dayjs().add(-16, 'hour').add(-6, 'day').toDate(), dayjs().add(-16, 'hour').toDate()];
            }
          },
          {
            text: '近一个月',
            value() {
              return [dayjs().add(-16, 'hour').add(-1, 'month').toDate(), dayjs().add(-16, 'hour').toDate()];
            }
          }
        ]
      }
    }
  },
  methods: {
    changeTimeZone(e) {
      if (e == 8) {
        console.log(dayjs(this.listDate[1]).add(16, 'hour').format('YYYY-MM-DD HH:mm:ss'))

        this.getListDate([dayjs(this.listDate[0]).add(16, 'hour').format('YYYY-MM-DD HH:mm:ss'), dayjs(this.listDate[1]).add(16, 'hour').format('YYYY-MM-DD HH:mm:ss')])
      } else this.getListDate([dayjs(this.listDate[0]).add(-16, 'hour').format('YYYY-MM-DD HH:mm:ss'), dayjs(this.listDate[1]).add(-16, 'hour').format('YYYY-MM-DD HH:mm:ss')])
    },
    handleExport() {
      this.exportLoading = true
      exportData({
        ...this.searchForm,
        startDate: dayjs(this.searchForm.startDate).format('YYYY-MM-DD'),
        endDate: dayjs(this.searchForm.endDate).format('YYYY-MM-DD'),
        advertiseTypes: this.searchForm.advertiseType || this.searchForm.advertiseType === 0 ? [this.searchForm.advertiseType] : [],
        channels: this.searchForm.channels && this.searchForm.channels != '-2' ? [Number(this.searchForm.channels)] : [],
      }).then(r => {
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = r.data.fileUrl
        // link.href = window.location.origin + r.data.fileUrl.substring(r.data.fileUrl.indexOf('/s_excel'), r.data.fileUrl.length)
        link.setAttribute('download', r.data.fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.exportLoading = false
      }).catch(e => {
        this.exportLoading = false
      })
    },
    handleSummary({ columns }) {
      const res = {}
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (!index) {
          sums[key] = {
            key,
            value: '合计'
          }
          return
        }
        let v = 0
        if (Number(this.sum[key])) {
          v = Number(this.sum[key])
        }
        sums[key] = {
          key,
          value: v && !column.notFixed ? (column.needCalc ? ((v * 100).toFixed(2) + '%' || '-') : v.toFixed(2)) : (this.sum[key] ? this.sum[key] : '0')
        }
      })

      return sums
    },
    submitColumn() {
      this.columns = this.column.map(i => {
        const obj = this.newColumn.find(j => j.key == i)
        return {
          title: obj.title,
          key: obj.key,
          index: obj.index,
          fixed: obj.fixed,
          width: obj.width,
          needCalc: obj.needCalc,
          maxWidth: obj.maxWidth,
          tooltip: !!obj.tooltip,
          tooltipMaxWidth: obj.tooltipMaxWidth,
          notFixed: obj.notFixed,
          slot: obj.slot,
          resizable: true,
          calc: obj.calc,
          // sortable: false,
          sortable: !obj.sortable ? false : 'custom',
          render: obj.render
        }
      })
      this.visible = false
      localStorage.setItem('data-field', JSON.stringify(this.columns))
      localStorage.setItem('data-field-flag', this.flag)

    },
    getListDate(data) {
      this.listDate = data
      this.searchForm.startDate = data[0]
      this.searchForm.endDate = data[1]
    },
    handleSort({ column, key, order }) {
      this.sortKey = key
      this.searchForm.sortKeyId = column.index

      if (order == 'asc') {
        this.searchForm.sortDesc = false
      } else {
        this.searchForm.sortDesc = true
      }
      if (order == 'normal') {
        this.searchForm.sortKeyId = null
        this.searchForm.sortDesc = null

      }
      this.getData()
    },
    getData(current) {
      this.loading = true
      if (current) this.page.current = current
      else this.page.current = 1

      getTableData({
        ...this.searchForm,
        startDate: dayjs(this.searchForm.startDate).format('YYYY-MM-DD'),
        endDate: dayjs(this.searchForm.endDate).format('YYYY-MM-DD'),
        advertiseTypes: this.searchForm.advertiseTypes || this.searchForm.advertiseTypes === 0 ? [this.searchForm.advertiseTypes] : [],
        channels: this.searchForm.channels && this.searchForm.channels != '-2' ? [Number(this.searchForm.channels)] : [],
        ...this.page
      }).then(({ data }) => {
        this.tableData = data.pageData.records || []
        this.page.total = data.pageData.total
        this.sum = data.sum
        this.loading = false
      })
    },
  },
  mounted() {
    const flag = localStorage.getItem('data-field-flag')
    if (flag) this.flag = Number(flag)
    this.newColumn = cloneDeep(this.columnData)
    this.flagColumn = this.newColumn.filter(i => !i.flag || i.flag == this.flag)
    const metric = localStorage.getItem('data-field')
    if (!metric) {
      this.column = this.flagColumn.map(i => i.key)
    } else {
      this.column = JSON.parse(metric).map(i => i.key)
    }
    this.submitColumn()
    this.getListDate([dayjs().add(-30, 'day').add(-16, 'hour').format('YYYY-MM-DD HH:mm:ss'), dayjs().add(-16, 'hour').format('YYYY-MM-DD HH:mm:ss')])
    this.getData()
    const scroll = this.$refs.tableRef.$el.querySelector(".ivu-table-body");
    const fixed = this.$refs.tableRef.$el.querySelector(".ivu-table-fixed-body");

    // 监听滚轮
    scroll &&
      scroll.addEventListener(
        "mousewheel",
        (e) => {
          if (scroll.scrollLeft <= 0 && e.deltaX < 0) {
            e.preventDefault();
          }
        },
        {
          passive: false,
        }
      );
    fixed &&
      fixed.addEventListener("wheel", (e) => {
        if(e.deltaX)e.preventDefault();
        e.preventDefault();
      });
  },
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;
  flex-wrap: wrap;

  &>* {
    margin: 0 5px 10px;

  }
}

.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

/deep/.ivu-table td,
.ivu-table th {
  height: 20px;
}

/deep/.ivu-table {
  .ivu-table-tbody {
    .ivu-table-row:last-child {
      height: 30px;

      td {
        vertical-align: top;
        height: 30px;
      }
    }

  }
}

/deep/.date-picker {
  .ivu-select-selection {
    border-right: none;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  .ivu-date-picker {
    input {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }
}

/deep/.ivu-table td,
.ivu-table th {
  height: v-bind(tableHeight) !important;
}

/deep/.ivu-table {
  .ivu-table-tbody {
    .ivu-table-row:last-child {
      height: 31px;

      td {
        vertical-align: top;
        height: 31px;
      }
    }

  }

  td {
    position: relative;

  }
}

/deep/ .ivu-table-border {
  th,
  td {
    border-color: #fff;

  }
}

/deep/.ivu-table-wrapper {
  border-color: #fff;
}
/deep/.ivu-table-fixed{
    pointer-events: none;
    &>*{
        pointer-events: auto;
    }
}
</style>
